// Lodge Config Reducer

import { initializeState } from '../../../utilities/storageUtils';
import lodgeConfigActionTypes from './lodgeConfig.types';

const INITIAL_STATE = {
  additionalPersonAmount: 0,
  affirmPubKey: '',
  filters: null,
  isFetchRestrictionsEnabled: false,
  isHighestRatesEnabled: false,
  isRateCalEnabled: false,
  updateSearchFullPageRefresh: false,
  isLoyaltyEnabled: false,
  loyaltyPointsToEarn: '',
  isInPrimerState: false,
  isOffersEnabled: false,
  loyaltyPointsMultiplier: 0.1,
  loyaltyEarnThresholdNights: 2,
  isLoyaltyReferralEnabled: false,
  isDiningPackagesEnhancedUIEnabled: true,
  isDynamicTileEnabled: false,
  hideOnlineCheckinText: false,
  perNightParkingFee1: '',
  perNightParkingFee2: '',
  perNightParkingFee3: '',
  parkingFeeStartDate: '',
  parkingFeeEndDate: '',
  creditCardAuthUrl: '',
  creditEnabled: false,
  affirmEnabled: false,
  applePayEnabled: false,
  googlePayEnabled: false,
  payPalEnabled: false,
  amexEnabled: false,
  isIFrameEnabled: false,
  shouldLeadGenPop: '',
  parkingFeeCallout: false,
  parkingFeeCalloutTitle: '',
  parkingFeeCalloutDescription: '',
  bookingSummaryParkingFee: '',
  uffTileEnabled: false,
  isLoyaltyPointsExpirationOnProfileEnabled: false,
  isCartActive: false,
  pricePerWaterPass: 0,
  isCancelReservationEnabled: false,
  isHoldCancelReservationEnabled: false,
  isAddGuestsEnabled: false,
  isRoomUnbundledRateWPAvailable: false,
  beginReservationsDate: null,
  maxOccupancy: 0,
  newPatchEndpoint: false,
  showPackagesInAddGuestsModal: false,
  suitePriceIncludedTaxesAndFees: [],
  taxAndFeeLabels: '',
  birthdayPartyInclusionList: [],
  isBdayBookingWidgetActive: false,
  partyKidsPerAdultRatio: 4,
  partyMaxGuestCount: 20,
  minimumBookingDaysRestriction: 3,
  maximumBookingDaysRestriction: 90,
  isManageYourReservationEnabled: false,
  showDiningPageInUFFFlow: false,
  showResortFeeModal: false,
  showHighlightBadge: false,
  stickyBottomBookingWidget: false,
  ageThreshold: 21,
  isLowestRatesRestrictionsEnabled: false,
  idMeParameters: null,
  isChangeDatesEnabled: false,
  maxSpectatorsCount: 9,
  isStaticDaypassEnabled: false,
  isAddGuestAPS: false,
  showAdventurePassesBeforeAttractionPassesInPreCheckInFlow: false,
  suiteCardVersionKEnabled: false,
  enableMemberRates: false,
  daypassTicketLimit: null,
  isTaxOnlyMessage: false,
  promosForShortMessaging: [],
  isSleepUpToCase: false,
  lowestToHighestAttractionPasses: false,
  taxesExcluded: false,
  // THIS IS A TEMP FLAG FOR SYNCING UFF REDESIGN CHANGES, #72251 - #78260 - #78261
  // TO BE DELETED ON RELEASE
  tempUffRedesignActive: false,
  // THIS IS A TEMP FLAG FOR SYNCING UFF REDESIGN CHANGES, #72251 - #78260 - #78261
  // TO BE DELETED ON RELEASE
  packMembersLimit: 10,
  hiddenOfferPrefixes: null
};

const lodgeConfigReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);
  switch (action.type) {
    case lodgeConfigActionTypes.ID_ME_DATA_PARAMETERS:
      return {
        ...state,
        idMeParameters: action.idMeParameters
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_DAYPASS:
      return {
        ...state,
        daypassTicketLimit: action.daypassTicketLimit
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING:
      return {
        ...state,
        isLoyaltyEnabled: action.isLoyaltyEnabled,
        isInPrimerState: action.isInPrimerState,
        isOffersEnabled: action.isOffersEnabled,
        loyaltyPointsMultiplier: action.loyaltyPointsMultiplier,
        isLoyaltyReferralEnabled: action.isLoyaltyReferralEnabled,
        isLoyaltyPointsExpirationOnProfileEnabled: action.isLoyaltyPointsExpirationOnProfileEnabled,
        loyaltyPointsToEarn: action.loyaltyPointsToEarn,
        loyaltyEarnThresholdNights: action.loyaltyEarnThresholdNights,
        isHoldCancelReservationEnabled: action.isHoldCancelReservationEnabled
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PLAN:
      return {
        ...state,
        additionalPersonAmount: action.config.additionalPersonAmount,
        affirmPubKey: action.config.affirmPubKey,
        filters: action.config.filters,
        isFetchRestrictionsEnabled: action.config.isFetchRestrictionsEnabled,
        isHighestRatesEnabled: action.config.isHighestRatesEnabled,
        isRateCalEnabled: action.config.isRateCalEnabled,
        updateSearchFullPageRefresh: action.config.updateSearchFullPageRefresh,
        includeResortFeeInSuitePrice: action.includeResortFeeInSuitePrice,
        pricePerWaterPass: action.config.pricePerWaterPass,
        isRoomUnbundledRateWPAvailable: action.config.isRoomUnbundledRateWPAvailable,
        suitePriceIncludedTaxesAndFees: action.config.suitePriceIncludedTaxesAndFees,
        showDiningPageInUFFFlow: action.config.showDiningPageInUFFFlow,
        showResortFeeModal: action.config.showResortFeeModal,
        showHighlightBadge: action.config.showHighlightBadge,
        suiteCardVersionKEnabled: action.config.suiteCardVersionKEnabled,
        enableMemberRates: action.config.enableMemberRates,
        isTaxOnlyMessage: action.config.isTaxOnlyMessage,
        promosForShortMessaging: action.config.promosForShortMessaging,
        isSleepUpToCase: action.config.isSleepUpToCase,
        lowestToHighestAttractionPasses: action.config.lowestToHighestAttractionPasses,
        taxesExcluded: action.config.taxesExcluded
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CREDIT_PACKAGE:
      return {
        ...state,
        isDiningPackagesEnhancedUIEnabled: action.isDiningPackagesEnhancedUIEnabled,
        showAdventurePassesBeforeAttractionPassesInPreCheckInFlow:
          action.showAdventurePassesBeforeAttractionPassesInPreCheckInFlow
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CMP:
      return {
        ...state,
        isDynamicTileEnabled: action.isDynamicTileEnabled,
        hideOnlineCheckinText: action.hideOnlineCheckinText,
        parkingFeeCallout: action.parkingFeeCallout,
        parkingFeeCalloutTitle: action.parkingFeeCalloutTitle,
        parkingFeeCalloutDescription: action.parkingFeeCalloutDescription,
        uffTileEnabled: action.uffTileEnabled,
        isCancelReservationEnabled: action.isCancelReservationEnabled,
        showPackagesInAddGuestsModal: action.showPackagesInAddGuestsModal,
        isManageYourReservationEnabled: action.isManageYourReservationEnabled,
        isAddGuestsEnabled: action.isAddGuestsEnabled,
        isChangeDatesEnabled: action.isChangeDatesEnabled,
        isStaticDaypassEnabled: action.isStaticDaypassEnabled,
        isAddGuestAPS: action.isAddGuestAPS,
        lowestToHighestAttractionPasses: action.lowestToHighestAttractionPasses
      };
    /* ABCD TEST FOR PARKING FEE */
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PAYMENT:
      return {
        ...state,
        perNightParkingFee1: action.perNightParkingFee1,
        perNightParkingFee2: action.perNightParkingFee2,
        perNightParkingFee3: action.perNightParkingFee3,
        parkingFeeStartDate: action.parkingFeeStartDate,
        parkingFeeEndDate: action.parkingFeeEndDate,
        creditCardAuthUrl: action.creditCardAuthUrl,
        creditEnabled: action.creditEnabled,
        affirmEnabled: action.affirmEnabled,
        applePayEnabled: action.applePayEnabled,
        googlePayEnabled: action.googlePayEnabled,
        payPalEnabled: action.payPalEnabled,
        amexEnabled: action.amexEnabled,
        isIFrameEnabled: action.isIFrameEnabled,
        taxAndFeeLabels: action.taxAndFeeLabels,
        bookingSummaryParkingFee: action.bookingSummaryParkingFee
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_LEADGEN:
      return {
        ...state,
        shouldLeadGenPop: action.shouldLeadGenPop
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_USER_SETTINGS:
      return {
        ...state,
        newPatchEndpoint: action.newPatchEndpoint
      };
    case lodgeConfigActionTypes.RESET_LODGE_CONFIG:
      return {
        ...INITIAL_STATE
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CART:
      return {
        ...state,
        isCartActive: action.config.isCartActive
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_BOOKING_WIDGET:
      return {
        ...state,
        beginReservationsDate: action.beginReservationsDate,
        maxOccupancy: action.maxOccupancy,
        ageThreshold: action.ageThreshold || state.ageThreshold,
        isLowestRatesRestrictionsEnabled: action.isLowestRatesRestrictionsEnabled,
        stickyBottomBookingWidget: action.stickyBottomBookingWidget,
        // THIS IS A TEMP FLAG FOR SYNCING UFF REDESIGN CHANGES, #72251 - #78260 - #78261
        // TO BE DELETED ON RELEASE
        tempUffRedesignActive: action.tempUffRedesignActive,
        // THIS IS A TEMP FLAG FOR SYNCING UFF REDESIGN CHANGES, #72251 - #78260 - #78261
        // TO BE DELETED ON RELEASE
        hiddenOfferPrefixes: action.hiddenOfferPrefixes
      };
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PARTY_BOOKING_WIDGET:
      return {
        ...state,
        isBdayBookingWidgetActive: action.isBdayBookingWidgetActive,
        birthdayPartyInclusionList: action.birthdayPartyInclusionList,
        partyKidsPerAdultRatio: action.partyKidsPerAdultRatio,
        partyMaxGuestCount: action.partyMaxGuestCount,
        minimumBookingDaysRestriction: action.minimumBookingDaysRestriction,
        maximumBookingDaysRestriction: action.maximumBookingDaysRestriction,
        maxSpectatorsCount: action.maxSpectatorsCount
      };
    /* ABCD TEST FOR PARKING FEE */
    case lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PROFILE:
      return {
        ...state,
        packMembersLimit: action.packMembersLimit
      };
    default:
      return state;
  }
};

export default lodgeConfigReducer;
